import { render, staticRenderFns } from "./PriceListPortal.vue?vue&type=template&id=edfa8c46&scoped=true&"
import script from "./PriceListPortal.vue?vue&type=script&lang=js&"
export * from "./PriceListPortal.vue?vue&type=script&lang=js&"
import style0 from "./PriceListPortal.vue?vue&type=style&index=0&id=edfa8c46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfa8c46",
  null
  
)

export default component.exports